import { SVGProps, Ref, forwardRef } from 'react';

export const AUSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M14.222 2H1.778q-.137 0-.269.02l-.001.81-1.214-.002A1.9 1.9 0 0 0 0 3.846v8.308C0 13.174.796 14 1.778 14h12.444c.982 0 1.778-.827 1.778-1.846V3.846C16 2.826 15.204 2 14.222 2"
            fill="#00247D"
        />
        <path
            d="m4 11.703-.543.521.054-.766-.731-.116.61-.434-.369-.666.707.225L4 9.752l.272.715.707-.225-.369.666.61.434-.73.116.054.766zm8.422-7.597-.355.34.035-.501-.478-.076.4-.284-.242-.435.462.147.178-.468.178.468.463-.147-.241.435.399.284-.478.076.035.501zm-1.778 2.769-.355.34.035-.5-.478-.076.4-.284-.242-.436.463.147.177-.467.179.467.462-.147-.241.436.4.284-.48.076.036.5zm4-.923-.355.34.035-.5-.478-.076.4-.284-.242-.436.463.147.177-.467.179.467.462-.147-.241.436.4.284-.48.076.036.5zm-2.222 6.461-.355.341.035-.5-.478-.077.4-.284-.242-.436.462.148.178-.468.178.468.463-.148-.241.436.399.284-.478.076.035.501zm1.356-5.336.13.275.292.044-.21.214.05.302-.262-.143-.262.143.05-.302-.21-.214.291-.044z"
            fill="white"
        />
        <path
            d="M8.444 8V2H1.778c-.142 0-.269.02-.269.02l-.001.81-1.214-.002s-.018.028-.056.095A1.9 1.9 0 0 0 0 3.846V8z"
            fill="#00247D"
        />
        <path
            d="M8.444 2H7.408L5.333 3.509V2H3.111v1.186L1.51 2.02c-.273.043-.529.15-.743.307l2.09 1.518h-.772L.43 2.642a2 2 0 0 0-.136.186l1.4 1.018H0v2.308h1.727L0 7.43V8h1.48l1.631-1.185V8h2.222V6.491L7.408 8h1.036v-.936l-1.25-.91h1.25V3.846h-1.25l1.25-.91z"
            fill="#EEEEEE"
        />
        <path d="M4.889 2H3.556v2.308H0v1.384h3.556V8h1.333V5.692h3.555V4.308H4.89z" fill="#CF1B2B" />
        <path
            d="M8.444 2h-.649L5.333 3.79v.056h.699l2.412-1.755zm-7.678.328q-.187.135-.336.314l1.654 1.204h.772zm2.095 3.826L.326 8h.768L3.11 6.533v-.38zm5.583 1.755v-.563L6.806 6.154H6.03z"
            fill="#CF1B2B"
        />
    </svg>
));
AUSize16Glyph.displayName = 'AUSize16Glyph';
